import * as React from 'react';
import { Link } from 'react-router-dom'
import { useTranslation } from "react-i18next";
import { avaiableLangList } from '../../i18nextConf'
import { Grid, GridToolbar, GridColumn as Column } from '@progress/kendo-react-grid';
import FunctionalGroupsService from "../../services/FunctionalGroups.service";
import LanguagesService from "../../services/Languages.service";
import { CustomListCommandCell } from "../../components/GridCustomListCommandCell";
import { GridCustomLoadingCell } from "../../components/GridCustomLoadingCell";
import { PanelCustomLoader } from "../../components/PanelCustomLoader";

export default function List(props) {

    const { t } = useTranslation();
    const isAdmin = props.isAdmin;

    const CommandCell = props => (
        <CustomListCommandCell
            {...props}
            editField='inEdit'
            remove={remove}
            linkToDetails={'/FunctionalGroups/' + props.dataItem.functionalGroupId + '/Edit'}
            isAdmin={isAdmin}
        />
    );

    const [results, setResults] = React.useState(0);
    const [functionalGroups, setFunctionalGroups] = React.useState([]);
    const [loading, setLoading] = React.useState(true);
    const [selectedLenguage, setSelectedLenguage] = React.useState({ name: 'Loading...', languageId: "es-ES" });

    React.useEffect(() => {
        LanguagesService.getLanguages()
            .then(response => response.data.contract)
            .then(json => {

                var selected = localStorage.getItem("i18nextLng") || "en";
                var selectedLangDetails = avaiableLangList.find(lang => lang.short === selected);
                var defaultLang = json.find(lang => lang.languageId === selectedLangDetails.id);

                setSelectedLenguage(defaultLang);
            });


    }, [t]);

    React.useEffect(() => {

        setLoading(true);

        FunctionalGroupsService.getFunctionalGroups(selectedLenguage.languageId)
            .then(response => response.data)
            .then(json => {
                setFunctionalGroups(json.contract);
                setResults(json.totalResults);
                setLoading(false);
            });
    }, [selectedLenguage]);


    const remove = (dataItem) => {

        FunctionalGroupsService.delete(dataItem).then(response => {

            FunctionalGroupsService.getFunctionalGroups(selectedLenguage.languageId)
                .then(response => response.data)
                .then(json => {
                    setFunctionalGroups(json.contract);
                    setResults(json.contract.length);
                    setLoading(false);
                });

        });

    }

    return (
        <div>
            {loading && PanelCustomLoader}

            <Grid
                data={functionalGroups}
                editField='inEdit'
                total={results}
                scrollable={'none'}
                cellRender={GridCustomLoadingCell}
            >
                {isAdmin ? (<GridToolbar>
                    <div>
                        <Link to={'/FunctionalGroups/Add'}>
                            <button title={t("FunctionalGroups_Button_Tooltip_New")} className="k-button k-primary">
                                &nbsp;<span className="k-icon k-i-plus-circle" />&nbsp; {t("Global_Button_Text_New")} &nbsp;
                        </button>
                        </Link>
                    </div>
                </GridToolbar>) : (<span />)}
                <Column cell={CommandCell} width={isAdmin ? ("160px") : ("80px")} sortable={false} />
                <Column field="functionalGroupId" title={t("FunctionalGroups_ID_Label")} />
                <Column field="name" title={t("FunctionalGroups_Name_Label")} />
            </Grid>
        </div>
    );
}
